import axios from '../utils/axios';

export default function fetchCourseViewLeads(adminId,courseId,params) {
    return (
        axios.get('/admin/' + adminId +'/courses/course/' + courseId + '/page-visited-leads',  {params} )
    )
}